import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import { careerThemeColor, careerWorkHistory } from '../content/careerContent';

const Career = ({ theme }) => {
  const navigate = useNavigate();

  if (theme === 'professional') {
    return (
      <ProfessionalPage title="Career">
        {careerWorkHistory.map((job) => (
          <section key={job.company + job.title} className="professional-section">
            <h3>{job.title}</h3>
            <p><strong>{job.company}</strong></p>
            <p>{job.date}</p>
            {job.location && <p>{job.location}</p>}
            {job.achievements && job.achievements.length > 0 ? (
              <ul className="professional-job-achievements">
                {job.achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            ) : (
              <p>Role summary coming soon.</p>
            )}
          </section>
        ))}
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title="My Career" glowColor="#0066ff" className="blue-scroll" onEsc={() => navigate('/') }>
        <h2 className="career-title" style={{ color: careerThemeColor, letterSpacing: 1 }}>Work History</h2>
        <div className="career-list">
          {careerWorkHistory.map((job) => (
            <article key={job.company + job.title} className="career-card" style={{ ['--accent']: careerThemeColor }}>
              <header className="career-header">
                <div className="career-role">{job.title}</div>
                <div className="career-company">@ {job.company}</div>
              </header>
              <div className="career-meta">
                {job.type && <span>{job.type}</span>}
                {job.location && <span>{job.location}</span>}
                {job.date && <span>{job.date}</span>}
              </div>
              {job.achievements && job.achievements.length > 0 && (
                <ul className="career-achievements">
                  {job.achievements.map((ach, i) => (
                    <li key={i}>{ach}</li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>
      </PageGlowContainer>
    </>
  );
};

export default Career; 